import axios from "@/utils/axios";
import type { GymInfo, UpdateGymInfoParams } from "./type";

export const getGymInfo = async () => {
  const response = await axios.post<{ gym: GymInfo }>("/api/gym/get");
  return response.data.gym;
};

export const updateGymInfo = async (params: UpdateGymInfoParams) => {
  const { name, ...rest } = params;
  const response = await axios.post("/api/gym/update", {
    gym_info: rest,
  });
  return response.data;
};

export const updateGymLogo = async (image: File) => {
  const formData = new FormData();
  formData.append("image", image);

  const response = await axios.post("/api/gym/update_logo_image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const updateGymBanner = async (image: File) => {
  const formData = new FormData();
  formData.append("image", image);

  const response = await axios.post("/api/gym/update_banner_image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
